export default {
    methods: {
        async updatePinQuiz (id, isPin) {
            await this.$store.dispatch('quiz/updatePinQuiz', {
                id: id,
                form: {
                    is_pin_quiz: isPin
                }
            })
            .then(() => {
                window.shout.success('Update pin quiz success')
            })
            .catch(() => {
                window.shout.error('Update pin quiz fail')
            })
        }
    }
}
